import { queryOptions } from '@tanstack/react-query'
import { authClient } from './auth-client'

export const sessionQuery = queryOptions({
  queryKey: ['session'],
  queryFn: async () => {
    const { data, error } = await authClient.getSession()
    if (error) throw new Error(error.message ?? 'Could not load your session')
    return data
  },
  staleTime: 60_000,
})

export const workspacesQuery = queryOptions({
  queryKey: ['workspaces'],
  queryFn: async () => {
    const { data, error } = await authClient.organization.list()
    if (error) throw new Error(error.message ?? 'Could not load workspaces')
    return data ?? []
  },
  staleTime: 60_000,
})

/** Only follow same-site, path-only redirects (no open redirects). */
export function safeRedirect(target: unknown, fallback = '/') {
  return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') ? target : fallback
}
